import { Dropdown, Flex, Image, MenuProps, Space } from 'antd';
import React, { useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import { ALL_APP_CONFIGS } from '@/pages/sub-app/config';
import { isMobile } from '@/utils';

import styles from './index.module.less';
import classNames from 'classnames';
import useStore from '@/hooks/use-store';

interface Props {
  fixed?: boolean;
  theme?: 'light' | 'dark';
  style?: React.CSSProperties;
}

const Logo = (props: Props) => {
  const navigate = useNavigate();
  const { theme = 'light', style, fixed = false } = props;
  const {
    currentSubAppKey,
    setCurrentSubAppKey,
    setSubAppAvatarFunctions,
    setHeaderStyle,
    headerStyle,
  } = useStore();

  const goToHome = useCallback(() => {
    // 移动端不跳转
    if (isMobile()) {
      return;
    }
    setCurrentSubAppKey('');
    setHeaderStyle('system');
    setSubAppAvatarFunctions([]);
    navigate('/');
  }, [setCurrentSubAppKey, setHeaderStyle, setSubAppAvatarFunctions, navigate]);

  const menuItems = useMemo<MenuProps['items']>(
    () =>
      Object.keys(ALL_APP_CONFIGS)
        .filter((key) => !!ALL_APP_CONFIGS[key].url[import.meta.env.VITE_APP_ENV])
        .map((key) => ({
          label: (
            <Flex
              style={{
                height: 40,
                backgroundColor:
                  currentSubAppKey === ALL_APP_CONFIGS[key].key ? '#F6F7FB' : 'transparent',
              }}
              align="center"
              justify="center"
            >
              <Image style={{ height: 16 }} preview={false} src={ALL_APP_CONFIGS[key].logo} />
              {/* <span>{ALL_APP_CONFIGS[key].name}</span> */}
            </Flex>
          ),
          key,
          onClick: () => {
            setHeaderStyle(ALL_APP_CONFIGS[key].header);
            setCurrentSubAppKey(ALL_APP_CONFIGS[key].key);
            navigate(`/app/${ALL_APP_CONFIGS[key].key}`);
          },
        })),
    [navigate, setCurrentSubAppKey, setHeaderStyle, currentSubAppKey]
  );

  return (
    <>
      {headerStyle === 'system' ? (
        <div
          className={classNames(
            theme === 'dark' && styles['logo-container'],
            theme === 'light' && styles['logo-container-light']
          )}
          style={style}
          onClick={goToHome}
        >
          <div className={styles.logo} />
        </div>
      ) : (
        <div
          className={classNames(
            theme === 'dark' && styles['logo-container'],
            theme === 'light' && styles['logo-container-light'],
            fixed && styles['logo-container-fixed']
          )}
          style={style}
          onClick={goToHome}
        >
          <div className={styles.logo} />
        </div>
      )}
    </>
  );
};

export default React.memo(Logo);
